"use client";

import React from "react";
import styled from "styled-components";
import IconCross from "@lmn/lastminute-react-icons/icons-converted/lastminute-icons-solid/IconCross.js";

interface ChipProps {
  label: string;
  onClose?: () => void;
}

const ChipContainer = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  white-space: nowrap;
  background-color: ${({ theme }) =>
    theme.kallisto.color.background.interactive.backgroundPrimarySelected};
  border: 1px solid
    ${({ theme }) =>
      theme.kallisto.color.background.interactive.backgroundPrimarySelected};
  border-radius: 100px;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) =>
    theme.kallisto.color.text.interactive.textPrimaryDefault};
  cursor: pointer;
  &:hover {
    border: 1px solid
      ${({ theme }) =>
        theme.kallisto.color.border.interactive.borderPrimaryDefault};
  }
`;

const CrossIcon = styled(IconCross)`
  color: ${({ theme }) =>
    theme.kallisto.color.icon.interactive.iconPrimaryDefault};
`;

const Chip: React.FC<ChipProps> = ({ label, onClose }) => {
  if (!onClose) return <ChipContainer as="div">{label}</ChipContainer>;

  return (
    <ChipContainer onClick={onClose} aria-label={`Remove ${label} filter`}>
      {label}
      <CrossIcon size={12} />
    </ChipContainer>
  );
};

export default Chip;
